module.exports = __webpack_public_path__ + "static/media/number.6b8f20c9.png";